import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { GraduationCap, CheckCircle, BookOpen, Users, Target, Award } from 'lucide-react';
import CommonContactUs from './CommonContactUs';

const TechTrainingPage = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-[#1A193B] pt-20 text-white">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-3 lg:px-4 py-24 lg:py-32">
        <div className="container mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              Tech Training
            </h1>
            <p className="text-xl md:text-2xl text-indigo-100 mb-6">
            Upskill your team with cutting-edge technical training_
            </p>
            <p className="text-lg text-indigo-200">
              Our Services
            </p>
          </motion.div>
        </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-white">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex items-center gap-4 mb-6"
            >
              <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-500 flex-shrink-0">
                <GraduationCap className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800">
                Tech Training Services
              </h2>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-lg text-gray-600 mb-8"
            >
             Our tech training programs help organizations upskill their teams with cutting-edge technical knowledge delivered by industry experts. We design customized training solutions that address your specific needs and business objectives.
              </motion.p>

            {/* Services Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Our Training Offerings
              </h3>
              <div className="space-y-4">
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Custom Curricula
                    </h4>
                    <p className="text-gray-600">
                    We develop tailored training programs that address your organization's specific technical needs and skill gaps. Our custom curricula are designed to align with your business goals and technology stack. </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Hands-on Workshops
                    </h4>
                    <p className="text-gray-600">
                    Our interactive workshops provide practical, hands-on experience with the latest technologies and methodologies. Participants learn by doing, ensuring they can apply new skills immediately. </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Certification Programs
                    </h4>
                    <p className="text-gray-600">
                    We offer preparation courses for industry-recognized certifications, helping your team validate their skills and expertise in specific technologies and domains </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">                    Skill Assessments
                    </h4>
                    <p className="text-gray-600">
Our comprehensive skill assessments help identify knowledge gaps and track progress throughout the training process, ensuring measurable results.
                    </p>
                  </div>
                </div>
                {/* <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Emerging Technologies</h4>
                    <p className="text-gray-600">
                      Training on cutting-edge technologies like AI, machine learning, blockchain, cloud computing, and DevOps practices.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Ongoing Learning Support</h4>
                    <p className="text-gray-600">
                      Continuous learning resources, mentorship programs, and access to learning platforms to support ongoing development.
                    </p>
                  </div>
                </div> */}
              </div>
            </motion.div>

            {/* Training Formats Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="bg-indigo-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Training Delivery Formats
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <Users className="w-5 h-5 text-indigo-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">In-Person Training</h4>
                    <p className="text-gray-600">Interactive classroom sessions with hands-on exercises and direct instructor guidance.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <BookOpen className="w-5 h-5 text-indigo-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Online Learning</h4>
                    <p className="text-gray-600">Flexible e-learning modules with self-paced content and virtual instructor support.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Target className="w-5 h-5 text-indigo-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Hybrid Programs</h4>
                    <p className="text-gray-600">Combination of online and in-person training for optimal learning experience.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Award className="w-5 h-5 text-indigo-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Workshop Series</h4>
                    <p className="text-gray-600">Intensive hands-on workshops focused on specific technologies or skills.</p>
                  </div>
                </div>
              </div>
            </motion.div> */}

            {/* Process Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Training Delivery Methods
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold mb-3">
                    1
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                  In-Person Training
                  </h4>
                  <p className="text-gray-600">
                  On-site training sessions conducted at your location, providing direct interaction with our expert trainers. </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold mb-3">
                    2
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                  Virtual Classrooms
                  </h4>
                  <p className="text-gray-600">
                  Live online training sessions that offer flexibility while maintaining interactive learning experiences.
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold mb-3">
                    3
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">
                  Hybrid Learning
                  </h4>
                  <p className="text-gray-600">
A combination of self-paced online modules and live sessions, providing the best of both worlds.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Technologies Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Technologies We Train On
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">JavaScript/React</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">Python/Django</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">Java/Spring</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">Node.js</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">AWS/Azure</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">Docker/Kubernetes</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">DevOps</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  <span className="text-gray-700">Data Science</span>
                </div>
              </div>
            </motion.div> */}

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex justify-center gap-4 flex-wrap"
            >
              <Link to="/services">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-gray-100 text-gray-800 hover:bg-gray-200 px-6 py-3 rounded-lg font-medium transition-colors shadow-md inline-flex items-center"
                >
                  <span>Back to Services</span>
                </motion.button>
              </Link>
              <Link to="/contact">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg shadow-lg flex items-center space-x-2 transition-colors duration-300"
                >
                  <GraduationCap size={18} />
                  <span>Contact Us</span>
                </motion.button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      {/* <section id="tech-training-contact" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="bg-white p-8 rounded-xl shadow-lg"
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                Get Started with Tech Training
              </h2>
              <p className="text-gray-600 mb-8 text-center">
                Ready to upskill your team? Contact us today to discuss your training needs and objectives.
              </p>
              
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Company Name *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                      placeholder="Your company name"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Contact Person *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                      placeholder="Your name"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                      placeholder="email@company.com"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                      placeholder="+1 (234) 567-8910"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Number of Participants
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                      placeholder="Number of team members to train"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Preferred Format
                    </label>
                    <select className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors">
                      <option value="">Select format</option>
                      <option value="in-person">In-Person Training</option>
                      <option value="online">Online Learning</option>
                      <option value="hybrid">Hybrid Program</option>
                      <option value="workshop">Workshop Series</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Training Requirements *
                  </label>
                  <textarea
                    required
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                    placeholder="Describe the skills and technologies you want your team to learn, current skill levels, and specific learning objectives..."
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Timeline & Budget
                  </label>
                  <textarea
                    rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-colors"
                    placeholder="Provide information about your preferred timeline, budget constraints, and any specific scheduling requirements..."
                  />
                </div>

                <div className="text-center">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    className="px-8 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors shadow-lg"
                  >
                    Request Tech Training Services
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </section> */}
       <section className="py-16 bg-[#1A193B] text-white">
        <CommonContactUs/>
      </section>
    </div>
  );
};

export default TechTrainingPage; 